import React from 'react';
import { AlertCircle, MapPin } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-[#FAF7F2]" data-id="element-134">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-135">
        <div className="bg-white rounded-[2rem] p-8 md:p-12 shadow-xl border border-[#E8F0EC] relative overflow-hidden" data-id="element-136">
          {/* Decorative corner */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#E8F0EC] rounded-bl-full -z-0 opacity-50" data-id="element-137" />

          <div className="relative z-10" data-id="element-138">
            <div className="flex items-center gap-4 mb-8" data-id="element-139">
              <div className="bg-[#1B5E5E] p-3 rounded-2xl text-white" data-id="element-140">
                <AlertCircle className="w-8 h-8" data-id="element-141" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold m-0" data-id="element-142">
                La Verdad Sobre Tus Rodillas
              </h2>
            </div>

            <div className="space-y-8 text-lg md:text-xl leading-relaxed text-gray-700" data-id="element-143">
              <p data-id="element-144">
                Después de los 65 años, el cartílago no desaparece por arte de
                magia, pero el líquido sinovial —el "aceite" de tus rodillas—{' '}
                <strong className="text-[#1B5E5E]" data-id="element-145">
                  deja de producirse correctamente
                </strong>
                .
              </p>

              <div className="bg-[#E8F0EC] p-6 md:p-8 rounded-2xl border-l-4 border-[#1B5E5E]" data-id="element-146">
                <div className="flex items-center gap-3 mb-4" data-id="element-147">
                  <MapPin className="w-6 h-6 text-[#1B5E5E]" data-id="element-148" />
                  <h3 className="text-2xl font-bold text-[#1B5E5E] m-0" data-id="element-149">
                    El Factor "Estados Unidos"
                  </h3>
                </div>
                <p className="mb-4" data-id="element-150">
                  Esto se agrava si vives en Estados Unidos:
                </p>
                <ul className="space-y-4 list-disc list-inside marker:text-[#C9A84C]" data-id="element-151">
                  <li data-id="element-152">
                    Pasas horas caminando sobre el concreto duro de los
                    supermercados.
                  </li>
                  <li data-id="element-153">
                    El frío de estados como Nueva York o Chicago entumece tus
                    piernas.
                  </li>
                  <li data-id="element-154">
                    El calzado moderno no está diseñado para proteger tu
                    columna.
                  </li>
                </ul>
              </div>

              <p className="text-xl md:text-2xl font-medium text-[#2D2D2D] text-center mt-8" data-id="element-155">
                El resultado es una rodilla rígida, inflamada y dolorosa que te
                roba la alegría de jugar con tus nietos o salir a caminar por el
                mall.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}